import { Alert } from '@designsforhealth/dfh-react-components'
import { Grid, Toolbar } from '@material-ui/core'
import React, { FC } from 'react'

import { SessionExpirationModal } from '../../components/auth/SessionExpirationModal'
import CheckoutAppBar from '../../components/buy/layout/CheckoutAppBar'
import MiniCartContainer from '../../components/buy/mini_cart/MiniCartContainer'
import ErrorAccessingMagentoMessage from '../../components/ErrorAccessingMagentoMessage'
import ErrorRetrievingDataMessage from '../../components/ErrorRetrievingDataMessage'
import Spinner from '../../components/Spinner'
import CheckoutNavigationBarOptionsProvider from '../../context/CheckoutNavigationBarOptionsProvider'
import { withAuthenticationRequiredOrAnonymousCart } from '../../hoc/withAuthenticationRequiredOrAnonymousCart'
import { isMagentoScopeNotGrantedError } from '../../lib/auth/errors'
import { useCartContext } from '../../lib/cart'
import { useCartRebateValidation } from '../../lib/cart/hooks/useCartRebateValidation'
import { usePatientBrowseDispensaryToast } from '../../lib/dispensaries/hooks/usePatientBrowseDispensaryToast'
import { useOnboardingToast } from '../../lib/onboarding/hooks/useOnboardingToast'
import { useUserPrivacyQualifiers } from '../../lib/privacy/hooks/useUserPrivacyQualifiers'
import LogoClickable from './LogoClickable'
import useStyles from './styles/sharedBuyLayout'

const SharedBuyLayout: FC = ({ children }) => {
  const classes = useStyles()

  const { cart, loading: cartLoading, error } = useCartContext()
  const { loading: rebateValidationLoading } = useCartRebateValidation()

  useOnboardingToast()
  useUserPrivacyQualifiers()
  usePatientBrowseDispensaryToast()

  return (
    <CheckoutNavigationBarOptionsProvider>
      <Grid className={classes.fullHeight} container direction="column" data-cy="layout-root">
        <CheckoutAppBar>
          <Toolbar>
            <LogoClickable />
            <MiniCartContainer />
          </Toolbar>
        </CheckoutAppBar>
        <Grid
          className={classes.flexGrow}
          alignItems="stretch"
          component="main"
          container
          justify="center"
          item
        >
          {rebateValidationLoading || cartLoading ? (
            <Spinner loading />
          ) : !cart ? (
            <Alert type="error">
              {isMagentoScopeNotGrantedError(error) ? (
                <ErrorAccessingMagentoMessage />
              ) : (
                <ErrorRetrievingDataMessage />
              )}
            </Alert>
          ) : (
            children
          )}
        </Grid>
      </Grid>
      <SessionExpirationModal />
    </CheckoutNavigationBarOptionsProvider>
  )
}

export default withAuthenticationRequiredOrAnonymousCart(SharedBuyLayout)
